// Which input a booking step should point the customer at next.
//
// fields: [{ name, done }] in on-screen order; each step decides what "done"
// means for its own field (e.g. a postal code is done at 6 digits). Returns
// the name of the first field that is not done, or null when all are.
// Pair with the highlight prop on ModernInput / ModernTextarea
// (components/commons/BookingFormComponents.js).
export const nextRequiredField = (fields) => fields.find(field => !field.done)?.name ?? null
